import { render } from "./ShoppingList.vue?vue&type=template&id=17baf6f8&scoped=true"
import script from "./ShoppingList.vue?vue&type=script&lang=js"
export * from "./ShoppingList.vue?vue&type=script&lang=js"

import "./ShoppingList.vue?vue&type=style&index=0&id=17baf6f8&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17baf6f8"]])

export default __exports__